const SectionCont2 = () => {
	return (
		<section className="sub-content cont2">
			<div className="sub-inner full">
				<p>"전환이 망설여진다면, 먼저 경험해보세요"</p>
			</div>
		</section>
	);
};

export default SectionCont2;
